(function ($, Drupal, once) {

    /* Logic to switch between tabs for content displayed on a single page */
    Drupal.behaviors.mitosCalendar = {

        attach: function (context, settings) {

          if($('#add-to-cal a').length) {
            $('#add-to-cal a').on('click', function() {
              $(this).parents().find('#add-to-cal').removeClass(('is-open'))

            });
          }
        }
    };
}(jQuery, Drupal, once));
